export default __webpack_public_path__ + "static/brassmoney-1864d43f04753edb78f3cd486b8604ce.png";